import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from '@emotion/styled';
import { makeStyles, createStyles } from '@material-ui/core/styles';
export var IMAGE_SIZE = {
  SCHOOL: {
    main: {
      height: '360px',
      width: '584px'
    },
    secondary: {
      height: '172px',
      width: '284px'
    }
  }
};
export var useStyle = makeStyles(function () {
  return createStyles({
    rootStyle: {
      display: 'flex',
      paddingRight: '40px',
      marginBottom: '16px',
      overflowX: 'scroll',
      position: 'relative'
    },
    carouselStyle: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    backdropStyle: {
      zIndex: 10000,
      // the tabs under has a zIndex of 1, top and leftNavBar have zIndex
      backgroundColor: 'rgba(0, 0, 0, 0.9)'
    },
    openButtonStyle: {
      position: 'absolute',
      left: '16px',
      bottom: '32px'
    }
  });
});
export var Image = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 8px;\n  object-fit: cover;\n  transition: linear filter 200ms;\n  cursor: zoom-in;\n\n  &:hover {\n    filter: brightness(0.5);\n  }\n"])));
export var List = styled.ul(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: grid;\n  justify-content: space-between;\n  grid-template-columns: repeat(auto-fill, ", ");\n  grid-gap: 16px;\n  grid-template-rows: repeat(2, ", ");\n  grid-auto-flow: column;\n\n  margin-left: 16px;\n  padding: 0;\n"])), IMAGE_SIZE.SCHOOL.secondary.width, IMAGE_SIZE.SCHOOL.secondary.height);
export var ListItem = styled.li(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  list-style-type: none;\n  position: relative;\n\n  height: ", ";\n"])), IMAGE_SIZE.SCHOOL.secondary.height);